import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class StartOn extends Field {
  static attributesForModel() {
    return ['startOn'];
  }

  get title() {
    return 'Start on';
  }

  exampleContents(): FieldContentsData {
    return {
      text: dateFormattedWithUserLocale(moment().subtract(3, 'months')),
      icon: { name: 'fa-regular fa-hourglass-start' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.startOn) {
      return {
        text: dateFormattedWithUserLocale(record.startOn),
        icon: { name: 'fa-regular fa-hourglass-start' },
      };
    }

    return {};
  }
}
